import React, { useState, useEffect } from "react";

import Container from "../../components/Shared/Container";
import FormContainer from "../../components/Shared/FormContainer";
import Logo from "../../components/Shared/Logo";

import LOGO_EN from '../../assets/UMlogo_en.png'
import LOGO_PL from '../../assets/UMlogo_pl.png'

import { useHistory } from "react-router";

const Form = () => {
	const [loadCount, setLoadCount] = useState(0);
	const [windowWidth, setWindowWidth] = useState(window.innerWidth);
	const history = useHistory();

	useEffect(() => {
		if (loadCount === 2) {
			history.push('/bloopers')
		}
		//	eslint-disable-next-line
	}, [loadCount])

	useEffect(() => {
		window.addEventListener('resize', () => setWindowWidth(window.innerWidth))
		return () => {
			window.removeEventListener('resize', setWindowWidth)
		}
		//	eslint-disable-next-line
	}, [])

	return (
		<Container
			align={'center'}
			justify={'center'}
		 	backrgroundColor={'white'}
		>
			<FormContainer>
				<Logo src={LOGO_PL} alt={'logo pl'}/>
				<iframe
					onLoad={() => setLoadCount(loadCount + 1)}
					title={'form'}
					scrolling={'no'}
					src="https://docs.google.com/forms/d/e/1FAIpQLScMamR36KYoizLYh9PG4MV-iHHPKkJHqbWhhGccOAkMoJ_NlA/viewform?embedded=true"
					width="100%"
					height={windowWidth > 502 ? "1000" : 1200}
					frameBorder="0"
					marginHeight="0"
					marginWidth="0"
				>
					Ładuję…
				</iframe>
				<Logo
					src={LOGO_EN}
					float={'right'}
					alt={'logo en'}/>
			</FormContainer>
		</Container>
	)
};

export default Form;